import { Button, Input, Modal, Rate } from "antd";
import { useMemo, useState } from "react";
import cx from "classnames";
import { useVerifySkill } from "@/hooks/useSkill";
import dayjs from "dayjs";
import { useRouter } from "next/router";

const ProfileModalVerifySkill = ({refetch}:{refetch: any}) => {
  const router = useRouter();

  const [rateValue, setRateValue] = useState<number>(0);
  const [comments, commentsSet] = useState<string | null>(null);

  const { isProcess, handleAction } = useVerifySkill();

  const getColor = (color: string) => {
    if (color === "yellow") {
      return "border-yellow";
    }

    return `border-${color}-500`;
  };

  const selectNotification = useMemo(() => {
    if(router?.query?.data) return JSON.parse(router?.query?.data as string);
    return null;
  },[router.query])

  const isOpen = useMemo(() => {
    if (router?.query?.m === "verify-skill") return true;
    return false;
  }, [router]);

  const onClose = () => {
    setRateValue(0);
    commentsSet("");
    router.replace({
      pathname: router.pathname,
      query: {}
    },undefined,{shallow: true});
  };

  return (
    <Modal
      open={isOpen}
      footer={false}
      title="Verify Skill"
      onCancel={() => {
        onClose();
        setRateValue(0);
      }}
    >
      <div
        className={cx([
          "border-l-2 pl-4 mb-8 mt-8",
          getColor(selectNotification?.color),
        ])}
      >
        <p className="text-base  text-white mb-2">{selectNotification?.description}</p>
        <p className="text-sm text-neutral-500">
          {dayjs(selectNotification?.createdAt).format("DD MMM, YYYY HH:mm")}
        </p>
      </div>

      <div className="mb-8">
        <label className="text-white font-semibold font-base flex mb-2">
          <p className="font-bold text-sm mr-2">Rate</p>
          <div className="text-xs text-red-500 mt-0.5">(required)</div>
        </label>
        <Rate onChange={setRateValue} value={rateValue} />
      </div>

      <div className="flex flex-col mb-10">
        <p className="font-bold text-sm">Comments</p>
        <Input.TextArea
          value={selectNotification?.message || comments}
          placeholder="Tell us more..."
          style={{ resize: "none" }}
          onChange={(e) => commentsSet(e.target.value)}
          showCount
          maxLength={500}
          allowClear
          rows={5}
        />
      </div>

      <div className="flex justify-end w-full">
        <Button
          type="primary"
          loading={!!isProcess}
          onClick={async () => {
            await handleAction(
              selectNotification?.userTo,
              selectNotification?.id,
              rateValue,
              "ACCEPTED",
              comments as string,
            )
            onClose();
            refetch();
          }}
        >
          Verify
        </Button>
      </div>
    </Modal>
  );
};

export default ProfileModalVerifySkill;
